<template>
	<i class="w-5 h-5 flex items-center justify-center">
		<svg
			class="h-5 w-5"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="M3 3l18 18"
			/>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="M10.584 10.587a2 2 0 002.828 2.83"
			/>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="M9.363 5.365A9.466 9.466 0 0112 5c4.418 0 8.418 2.475 9.542 7-.593 2.183-1.81 4.13-3.423 5.635m-2.676 1.099C14.603 18.888 13.328 19 12 19c-4.418 0-8.418-2.475-9.542-7 .593-2.183 1.81-4.13 3.423-5.635"
			/>
		</svg>
	</i>
</template>